import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class OutingIterationInvoiceService {

    url: string = environment.api.endpoint;

    constructor(private http: HttpClient) { }

    getByIteration(id: string): any {
        return this.http.get(`${this.url}/outingiterationinvoice/iteration/${id}`);
    }

    create(data: any) {
        return this.http.post(`${this.url}/outingiterationinvoice/create`, data);
    }

    update(id: string, data: any) {
        return this.http.put(`${this.url}/outingiterationinvoice/update/${id}`, data);
    }
}